require("!!/workspace/node_modules/script-loader/addScript.js")(require("!!/workspace/node_modules/raw-loader/index.js!/workspace/resources/js/extern/main.js"))